import { RadioGroup, RadioGroupItem } from "ui/components/radio-group";
import { formatDateForAPI } from "utils/utils";
import CalendarDatePicker from "ui/components/comp-507";
import { JOB_TYPES } from "@/lib/constants";
import { Button } from "ui/components/button";
import CommonSelect from "components/select";
import { DatePicker } from "components/date-picker-2";
import { Label } from "ui/components/label";
import { fetchBillableStatuses } from "./api";
import { useFetch } from "@/hooks/useFetch";
import useTableFilters from "@/hooks/useTableFilters";

export default function BillableFilters({
  filters,
  setFilters,
  setIsOpen,
  defaultFilters,
  clearFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      coordinator: undefined,
      status: undefined,
      billing_date: undefined,
      due_date: undefined,
      ...defaultFilters,
    },
    defaultFilters,
  });

  const handleApplyFilters = () => {
    applyFilters();
  };

  const { data: billableStatuses } = useFetch({
    queryKey: ["billable-statuses"],
    queryFn: fetchBillableStatuses,
  });

  return (
    <div className="w-full px-4 space-y-4">
      {/* Type Filter */}
      <div>
        <Label className="mb-2 text-sm">Type</Label>
        <RadioGroup
          value={localFilters?.type?._eq || ""}
          onValueChange={(value) =>
            handleSetLocalFilters({
              type: value ? { _eq: value } : undefined,
            })
          }
          className="grid grid-cols-2 gap-2"
        >
          {Object.entries(JOB_TYPES).map(([key, type]) => {
            if (key === "recurring") return;

            return (
              <div key={key} className="flex items-center gap-2">
                <RadioGroupItem
                  value={key}
                  id={`type-${key}`}
                  className="text-base"
                />
                <label
                  htmlFor={`type-${key}`}
                  className="text-sm cursor-pointer"
                >
                  {type.label}
                </label>
              </div>
            );
          })}
        </RadioGroup>
      </div>

      {/* Status Filter */}
      <div>
        <Label className="mb-2 text-sm">Status</Label>
        <CommonSelect
          placeholder="Select"
          value={localFilters?.status?._eq}
          onValueChange={(selectedItem) =>
            handleSetLocalFilters({
              status: { _eq: selectedItem?.id, __selectedItem: selectedItem },
            })
          }
          items={billableStatuses}
          className="!w-full"
        />
      </div>

      {/* Billing Date */}
      <div>
        <Label className="mb-2 text-sm">Billing Date</Label>
        <CalendarDatePicker
          stack={true}
          date={{
            from: localFilters?.billing_date?._gte,
            to: localFilters?.billing_date?._lte,
          }}
          setDate={(range) => {
            handleSetLocalFilters({
              billing_date: {
                _gte: range?.from ? formatDateForAPI(range.from) : undefined,
                _lte: range?.to ? formatDateForAPI(range.to) : undefined,
              },
            });
          }}
          className="w-full"
        />
      </div>

      {/* Due Date */}
      <div>
        <Label className="mb-2 text-sm">Due Date</Label>
        <CalendarDatePicker
          stack={true}
          date={{
            from: localFilters?.due_date?._gte,
            to: localFilters?.due_date?._lte,
          }}
          setDate={(range) => {
            handleSetLocalFilters({
              due_date: {
                _gte: range?.from ? formatDateForAPI(range.from) : undefined,
                _lte: range?.to ? formatDateForAPI(range.to) : undefined,
              },
            });
          }}
          className="w-full"
        />
      </div>

      {/* Action Buttons */}
      <div className="flex place-self-end gap-4">
        <Button variant="outline" onClick={clearLocalFilters}>
          Clear
        </Button>
        <Button onClick={handleApplyFilters}>Apply</Button>
      </div>
    </div>
  );
}
